import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useStore, useToast, useAuth, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SF_BLL_CNCL_LIST_SRCH, SG_BLL_CNCL_LIST } from "./services/OsciBllCnclService"; // 서비스
import dayjs from "dayjs";

/*
 * Bill Cancellation List
 * !== 고지 취소 목록 ==!
 */
export const OSCI0403001Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "cstmCd" },
            { area: "coCd" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "comnCd", comnCd: "OSC0096" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [isVisibleNewBtn, setIsVisibleNewBtn] = useState(false); // User define State !== 사용자 정의 스테이트 ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Cancellation List Search !== 고지 취소 목록 검색 ==!
        bllCnclSrch: useForm({
            defaultSchema: SF_BLL_CNCL_LIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || { dspoCd: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "M"] }),
                bllCstmOfceCd: auth.get("cstmCd"),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Cancellation List !== 고지 취소 목록 ==!
        bllCnclList: useGrid({
            defaultSchema: SG_BLL_CNCL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Cancellation List !== 고지 취소 목록 조회 ==!
        getBllCnclList: useFetch({
            api: (page = grid.bllCnclList.page) => {
                let data = {
                    ...form.bllCnclSrch.getValues(),
                    orgCd: auth.get("orgCd"),
                };
                return APIS.getBllCnclList(data, "N", page, grid.bllCnclList.size);
            },
            enabled: comnUtils.isEmpty(form.bllCnclSrch.errors),
            key: [grid.bllCnclList.page, grid.bllCnclList.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.bllCnclSrch.getValues(),
                    page: grid.bllCnclList.page,
                    size: grid.bllCnclList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Bill Cancellation List !== 고지 취소 목록 조회 ==!
        getBllCnclList: () => {
            form.bllCnclSrch.handleSubmit(
                (data) => {
                    grid.bllCnclList.setPage(0);
                    fetch.getBllCnclList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_BllCnclList: {
            cell: {
                bllNo: (props: any) => {
                    const { rowValues } = props;
                    return (
                        <span style={{ color: "blue" }} title={`${rowValues.bllNo}:${rowValues.cnclRqstSn}`}>
                            <Link
                                to={`${URLS.osci0403002q}/${rowValues.bllMgmtId}${
                                    rowValues.cnclRqstSn ? `?cnclRqstSn=${rowValues.cnclRqstSn}` : ""
                                }`}
                            >{`${rowValues.bllNo}`}</Link>
                        </span>
                    );
                },
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        // 버튼 컨트롤
        if (auth.get("authList").includes("auth_osci0021") || auth.get("authList").includes("auth_osci0003")) {
            setIsVisibleNewBtn(true);
        }
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllCnclSrch.schema.bllNo}></Group.Control>
                                <Group.Control {...form.bllCnclSrch.schema.txprTin}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllCnclSrch.schema.dspoDt}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllCnclSrch.schema.cnclStatCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllCnclSrch.schema.dspoCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.bllCnclSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getBllCnclList();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    grid.bllCnclList.exportExcel({
                                        /* 다운로드 엑셀 파일명 (확장자 없이), 기본값 Export(년월일시분초) */
                                        excelName: dayjs().format("YYYY-MM-DD HH:mm:ss") + "_" + pgeUid,
                                        /* 다운로드 엑셀 시트명 , 기본값 Sheet */
                                        sheetName: "Sheet Name",
                                    });
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Grid
                            {...grid.bllCnclList.grid}
                            data={fetch.getBllCnclList.data?.bllCnclList}
                            render={render.grid_BllCnclList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            {isVisibleNewBtn && (
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.osci0403003s + "/INSERT");
                        }}
                    ></Button>
                </Layout.Left>
            )}
        </Page>
    );
};
